import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { App } from '@capacitor/app';
import { NavController } from '@ionic/angular';
import { CapacitorAppService } from '@monorepo/services';

@Component({
  selector: 'monorepo-app-shell',
  templateUrl: './app-shell.component.html',
  styleUrls: ['./app-shell.component.scss'],
})
export class AppShellComponent implements OnInit {
  constructor(
    private capacitorAppService: CapacitorAppService,
    private router: Router,
    private navController: NavController,
  ) {
    this.capacitorAppService.onDeviceBack(() => {
      const currentPath = this.router.url;
      if (currentPath === '/landing') {
        if (confirm('Exit app?')) {
          App.exitApp();
        }
      } else {
        // TODO - AMAN - V2 Fix this and release in V2
        // const backPath = Organizi8Helper.getBackPath(currentPath);
        // console.log({ backPath });
        // if (backPath) {
        //   this.navController.navigateRoot(backPath);
        // } else {
        //   this.navController.navigateRoot('/landing');
        // }
      }
    });
  }

  ngOnInit(): void {}
}
